<template>
  <div class="row mb-5 py-3 mx-0 d-flex flex-wrap align-items-start"
       v-for="data in meetingHistoryData"
       :key="data.id"
       style="border-bottom: 1px solid #D8D8D8">

    <div class="col-6 col-sm-4 col-lg-1 mb-2">
      <span class="label-bold">Termin:</span> <br/>
      <span class="text-nowrap">{{ data.termin }}</span>
    </div>
    <div class="col-6 col-sm-4 col-lg-1 mb-2">
      <span class="label-bold">Startzeit:</span> <br/>
      {{ data.startTime }}
    </div>
    <div class="col-6 col-sm-4 col-lg-1 mb-2">
      <span class="label-bold">Endzeit:</span> <br/>
      {{ data.endTime }}
    </div>
    <div class="col-6 col-sm-4 col-lg-1 mb-2">
      <span class="label-bold">Anwesenheit:</span> <br/>
      {{ data.presenceTranslation }}
    </div>
    <div class="col-6 col-sm-4 col-lg-1 mb-2 text-md-right text-lg-left">
      <span class="label-bold">Einheiten:</span> <br/>
      {{ data.units }}
    </div>

    <div class="col-6 col-sm-4 col-lg-auto mb-2">
      <span class="label-bold">Überschreiben:</span> <br/>
      {{ data?.overwrite ? 'Ja' : 'Nein' }}
    </div>

    <div class="col-12 col-sm-8 col-lg-auto mb-2">
      <span class="label-bold">Unterschrift:</span> <br/>
      <template v-if="data?.caseManagementCoaching?.digitalSignature">
        <span v-if="!data.digitalSignatureImage" style="color: #cf1020; font-size: 0.85rem;">
          Fehlende Digitale Unterschrift
        </span>
        <span v-else>Ja</span>
      </template>
      <template v-else>
        {{ data?.signature ? 'Ja' : 'Nein' }}
      </template>
    </div>

    <div class="col-4 col-lg-1 mb-2">
      <span class="label-bold">Abger.:</span> <br/>
      {{ data?.billed ? 'Ja' : 'Nein' }}
    </div>
    <div class="col-4 col-lg-1 mb-2">
      <span class="label-bold">Bezahlt:</span> <br/>
      {{ data?.paid ? 'Ja' : 'Nein' }}
    </div>
    <div class="col-4 col-lg-1 mb-2">
      <span class="label-bold">Hausb.:</span> <br/>
      {{ data?.homeVisit ? 'Ja' : 'Nein' }}
    </div>

    <div class="col-12 mt-3 px-0">
      <div class="row bg-light mx-0 p-2 rounded">
        <div class="col-12 col-md-4 col-lg-3">
          <span class="module-label-bold">Coachart:</span> {{ data.coachTypeTranslation }}
        </div>
        <div class="col-12 col-md-8 col-lg-9 mt-2 mt-md-0">
          <span class="module-label-bold">Coach:</span> {{ data.coach?.firstName }} {{ data.coach?.lastName }}
        </div>
      </div>
    </div>

    <div class="col-12 mt-3" v-if="data.meetingType === 'pr'">
      <div class="row">
        <div class="col-12 col-md-6 mb-2">
          <span class="module-label-bold">Sitzungsthema:</span><br/>
          {{ data.meetingTopic }}
        </div>
        <div class="col-12 col-md-6">
          <span class="module-label-bold">Beschreibung:</span><br/>
          <span class="text-muted small">{{ truncateText(data.description) }}</span>
        </div>
      </div>
    </div>
  </div>

  <ModalConfirm
      v-model="showRevertHistoryModal"
      confirmation-question="Sind Sie sicher, dass Sie die Daten wiederherstellen?"
      :onConfirm="revertHistory">
  </ModalConfirm>
</template>

<script setup>
import {defineProps, onMounted, ref, toRefs} from "vue";
import {CloseToast, ErrorToast} from "@/components/VueToast";
import portalCoachingService from "@/api/Portal/SocioTherapyCoaching";
import ModalConfirm from "@/components/modal/ModalConfirm.vue";
import {truncateText} from "@/shared/portal/commonFunctions";

const meetingHistoryData = ref([])
const showRevertHistoryModal = ref(false)
const isLoaded = ref(false);
const historyId = ref(null)
const meetingType = ref('')

const props = defineProps({
  meetingId: {
    type: [Number, String],
    required: true,
  },
});

const meetingId = toRefs(props)['meetingId'];

async function getMeetingHistoryData() {
  try {
    const {data} = await portalCoachingService.getMeetingDataHistoryList(+meetingId.value);

    meetingHistoryData.value = data.data
  } catch (error) {
    await ErrorToast(error);
  }
}


// async function revertHistory() {
//   try {
//     await portalPrivateCoachingService.revertMeetingHistory(meetingType.value, +meetingId.value, +historyId.value);
//
//     meetingType.value = '';
//     historyId.value = '';
//     showRevertHistoryModal.value = false;
//   } catch (error) {
//     await ErrorToast(error);
//   }
// }


// function handleRevertHistoryModal(historyMeetingId, historyMeetingType) {
//   showRevertHistoryModal.value = true;
//   historyId.value = historyMeetingId;
//   meetingType.value = historyMeetingType
// }

onMounted(async () => {
  CloseToast();
  await getMeetingHistoryData(meetingId);

  isLoaded.value = true;
});
</script>

<style scoped>
.label-bold {
  font-size: 16px;
  font-weight: bold;
}

.module-label-bold {
  font-size: 16px;
  font-weight: bold;
  margin-right: 10px;
}
</style>